import React, { ReactElement } from 'react';
import classNames from 'classnames';
import styles from './CalendarWeekdays.css';

interface RenderWeekDaysProp {
  dayOfWeek: string
}

export type RenderDays = (props: RenderWeekDaysProp) => ReactElement

export interface CalendarWeekdaysProps extends CalendarWeekDaysBaseProps{
  daysOfWeek: string[],
}

export interface CalendarWeekDaysBaseProps {
  renderWeekDays?: RenderDays
  renderWeekends?: RenderDays
  weekendDays?: string[]
  weekDaysClasses?: CalendarWeekdaysClasses
}

interface CalendarWeekdaysClasses {
  weekday?: string;
  weekend?: string;
  root?: string;
}

export default function CalendarWeekDays({
  daysOfWeek,
  weekendDays = ['saturday', 'sunday'],
  renderWeekDays,
  renderWeekends,
  weekDaysClasses: classes,
}:CalendarWeekdaysProps) {
  return (
    <div className={styles.weekdays}>
      {daysOfWeek.map((dayOfWeek: string, index: number) => {
        const isWeekend = weekendDays.includes(dayOfWeek.toLowerCase())
        if (isWeekend && !!renderWeekends) {
          return renderWeekends({dayOfWeek})
        }
          
        if (!isWeekend && !!renderWeekDays) {
          return renderWeekDays({dayOfWeek})
        }

        return (
          <div
            key={index}
            className={classNames({
              [styles.weekDayWrapper]: true,
              [classes?.root || '']: !!classes?.root,
              [classes?.weekday || '']: !isWeekend && classes?.weekday,
              [classes?.weekend || '']: isWeekend && classes?.weekend,
            })}
          >
            <abbr
              aria-label={dayOfWeek}
              title={dayOfWeek}
            >
              {dayOfWeek.substring(0, 3)}
            </abbr>
          </div>
        )
      })}
    </div>
  )
}
